import { DEV } from "solid-js"
import type { Vector3 } from "three"
import Unexpected from "../../Exception/Unexpected.class"
import eightDirectionCurrents from "../direction/eightDirectionCurrents"
import type { CurrentEDCS } from "./CurrentEDCS.type"

export default function getEntityCurrentVector3(current: CurrentEDCS): Vector3 {
  const value = eightDirectionCurrents[current.edc]
  if (DEV && !value) {
    throw new Unexpected(`Invalid CurrentEDCS: ${JSON.stringify(current)}`)
  }
  return value!
}